module.exports = __webpack_public_path__ + "img/sc.1e3dd852.svg";